import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "explainType", "messageVariables"];
import AFormItem from "./hack/FormItem";
import cns from "classnames";
import React, { isValidElement } from "react";
import { getPrefixCls } from "../config";
import { jsx as _jsx } from "react/jsx-runtime";
export function FormItem(_ref) {
  var className = _ref.className,
    explainType = _ref.explainType,
    _ref$messageVariables = _ref.messageVariables,
    messageVariables = _ref$messageVariables === void 0 ? {} : _ref$messageVariables,
    props = _objectWithoutProperties(_ref, _excluded);
  var prefixCls = getPrefixCls("form");
  var mergedMessageVariables = messageVariables;
  if (props.children) {
    if (!props.label) {
      if ( /*#__PURE__*/isValidElement(props.children)) {
        var _props$children, _props$children$props;
        var label = (_props$children = props.children) === null || _props$children === void 0 ? void 0 : (_props$children$props = _props$children.props) === null || _props$children$props === void 0 ? void 0 : _props$children$props.label;
        if (label) {
          mergedMessageVariables = _objectSpread({
            label: label
          }, mergedMessageVariables);
        }
      }
    }
  }
  return /*#__PURE__*/_jsx(AFormItem, _objectSpread({
    prefixCls: prefixCls,
    messageVariables: mergedMessageVariables,
    className: cns(className, _defineProperty({}, "".concat(prefixCls, "-item-explain-tooltip"), explainType === "tooltip"))
  }, props));
}